import { Merge } from '@cv-invision/core';
import { components34Names } from './schemas/v34/components.enum';
import { components40Names } from './schemas/v40/components.enum';

const mergeComponentNames = <T extends any[]>(...enums: T) => { return {...enums} as any as Merge<T>; };
export const ComponentList = mergeComponentNames(components34Names, components40Names);